<template>
    <div class="module-layer5">
        <div class="layer-cnt">
            <div class="title"></div>
            <div class="top-nav">
                <div v-for="item in 3" :key="item" @click="handIdx(item)">
                    <img :src="navIdx == item ? require(`../../assets/img/layer5/${item}-active.png`) : require(`../../assets/img/layer5/${item}.png`)"
                        alt="" srcset="">
                </div>
            </div>
            <div class="r-cnt" v-for="sItem in list" v-if="navIdx == sItem.id">
                <div class="nav-1" v-if="sItem.id !== 2">
                    <swiper :options="featuresOptions" ref="featuresSwiper">
                        <swiper-slide v-for="(iconItem, idx) in sItem.imgUrl" :key="idx">
                            <div class="img-size">
                                <img :src="iconItem" alt="" srcset="">
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-button-prev-role"></div>
                    <div class="swiper-button-next-role"></div>
                    <div class="swiper-pagination-media"></div>

                </div>
            </div>
            <!-- 视频 -->
            <div class="r-cnt r-cnt-video" v-if="navIdx == 2">
                <swiper :options="videoOptions" ref="videoSwiper" @slideChange="videoSwiperChange">
                    <swiper-slide v-for="(psterItem, posterIdx) in posterImg" :key="posterIdx">
                        <div class=" img-size">
                            <img :src="psterItem.url" alt="" srcset="">
                            <div class="video-play-btn" @click="handlePlayerVideo(psterItem)"></div>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-button-prev-video"></div>
                <div class="swiper-button-next-video"></div>
                <div class="swiper-pagination-media-video"></div>
                <div class="swiper-video-size" v-if="videoFlag">
                    <video class="vd-video" loop autoplay playsinline="" ref="veoRef" style="width:100%">
                        <source :src="videoUrl" type="video/mp4" />
                    </video>
                </div>
            </div>

        </div>
        <div class="copy-right">
            <div class="cnt">

                <a href="https://useragreement-kr.ujoygames.co.kr/" target="_blank">
                    <div class="btn-useragreement cursor"></div>
                </a>
                <a href="https://privacypolicy-kr.ujoygames.co.kr/" target="_blank">
                    <div class="btn-privacypolicy cursor"></div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'app',
    data() {
        return {
            navIdx: 1,
            featuresOptions: {
                loop: true,
                // slidesPerView: 'auto',
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                allowTouchMove: true,
                pagination: {
                    el: '.swiper-pagination-media',
                    clickable: true,
                    bulletClass: 'custom-bullet',
                    bulletActiveClass: 'custom-bullet-active'
                },
                navigation: {
                    nextEl: '.swiper-button-next-role',
                    prevEl: '.swiper-button-prev-role',
                },

            },
            videoOptions: {
                loop: true,
                // slidesPerView: 'auto',
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                allowTouchMove: true,
                pagination: {
                    el: '.swiper-pagination-media-video',
                    clickable: true,
                    bulletClass: 'custom-bullet',
                    bulletActiveClass: 'custom-bullet-active'
                },
                navigation: {
                    nextEl: '.swiper-button-next-video',
                    prevEl: '.swiper-button-prev-video',
                },

            },
            list: [
                {
                    id: 1,
                    imgUrl: [
                        require('../../assets/img/layer5/nav-1/1.jpg'),
                        require('../../assets/img/layer5/nav-1/2.jpg'),
                        require('../../assets/img/layer5/nav-1/3.jpg'),
                        require('../../assets/img/layer5/nav-1/4.jpg'),
                        require('../../assets/img/layer5/nav-1/5.jpg'),
                    ]
                },
                // {
                //     id: 2,
                //     imgUrl: [
                //         require('../../assets/img/layer5/nav-3/1.png'),
                //         require('../../assets/img/layer5/nav-3/2.png'),
                //         require('../../assets/img/layer5/nav-3/3.png'),
                //         require('../../assets/img/layer5/nav-3/4.png'),
                //         require('../../assets/img/layer5/nav-3/5.png'),
                //     ]
                // },
                {
                    id: 3,
                    imgUrl: [
                        require('../../assets/img/layer5/nav-2/kv01.jpg'),
                        require('../../assets/img/layer5/nav-2/kv02.jpg'),
                        require('../../assets/img/layer5/nav-2/kv03.jpg'),
                        require('../../assets/img/layer5/nav-2/kv04.jpg'),
                        require('../../assets/img/layer5/nav-2/kv05.jpg'),
                    ]
                }
            ],
            posterImg: [
                {
                    idx: 1,
                    url: require('../../assets/img/layer5/nav-3/1.png'),
                },
                {
                    idx: 2,
                    url: require('../../assets/img/layer5/nav-3/2.png'),
                }, {
                    idx: 3,
                    url: require('../../assets/img/layer5/nav-3/3.png'),
                }, {
                    idx: 4,
                    url: require('../../assets/img/layer5/nav-3/4.png'),
                }, {
                    idx: 5,
                    url: require('../../assets/img/layer5/nav-3/5.png'),
                },


            ],
            videoUrl: 'https://resource-mp4.ujoygames.com/cof/01.mp4',
            videoFlag: false
        }
    },
    methods: {
        handIdx(val) {
            this.navIdx = val
            this.videoFlag = false
        },
        handlePlayerVideo(val) {
            this.videoFlag = !this.videoFlag
            if (this.videoFlag) {
                this.videoUrl = `https://resource-mp4.ujoygames.com/cof/0${val.idx}.mp4`
            }
        },
        videoSwiperChange() {
            this.videoFlag = false
        }
    }
}
</script>
<style lang="scss">
.module-layer5 {
    width: 100%;
    height: 100%;
    background: url('../../assets/img/layer5/bg.png') 50% no-repeat;
    background-size: cover;
    position: relative;

    .layer-cnt {
        width: 100%;
        position: absolute;
        top: 15%;

        .title {
            background-image: url("../../assets/img/layer5/title.png");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            width: 339px;
            height: 166px;
            margin: 0 auto;
        }

        img {
            width: 100%;
            height: 100%;
            display: block;
        }
    }

    .top-nav {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
        margin-top: 5%;

        img {
            display: block;
            width: 153px;
            height: 48px;
            margin-bottom: 1vw;
        }
    }

    .r-cnt-video {
        .video-play-btn {
            width: 140px;
            height: 140px;
            background: url('../../assets/img/layer1/play-btn.png') 50% no-repeat;
            background-size: cover;
            margin-bottom: 18vw;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .swiper-video-size {
            width: 638px;
            height: 360px;
            margin: 0 auto;
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 1;
            transform: translate(-50%, -50%);
            display: flex;
            align-items: center;
            justify-content: center;

            .vd-video {
                width: calc(100% - 12px);
                height: calc(100% - 12px);
                display: block;

            }
        }

    }

    .r-cnt,
    .r-cnt-video {
        width: 100%;
        position: relative;

        .swiper-slide {
            width: 80%;
            height: 100%;

            .img-size {
                width: 638px;
                height: 360px;
                margin: 0 auto;
                background-image: url("../../assets/img/layer5/img-border.png");
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                position: relative;


                img,
                video {
                    width: calc(100% - 12px);
                    height: calc(100% - 12px);
                    display: block;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }

            }
        }

        .swiper-button-prev-role:after,
        .swiper-button-prev-video:after {
            display: none;
        }

        .swiper-button-next-role:after,
        .swiper-button-next-video:after {
            display: none;
        }

        .swiper-button-prev-role,
        .swiper-button-prev-video {
            background: url("../../assets/img/layer5/prev.png") no-repeat top;
            background-size: 100% 100%;
            width: 30px;
            height: 47px;
            top: 45%;
            position: absolute;
            z-index: 1;
        }

        .swiper-button-next-role,
        .swiper-button-next-video {
            background: url("../../assets/img/layer5/next.png") no-repeat top;
            background-size: 100% 100%;
            width: 30px;
            height: 47px;
            top: 45%;
            position: absolute;
            z-index: 1;
            right: 0;
        }

        .swiper-pagination-media,
        .swiper-pagination-media-video {
            position: absolute;
            bottom: -10%;
            display: flex;
            justify-content: center;
            gap: 24px;
            left: 50%;
            transform: translateX(-50%);

            .custom-bullet {
                display: inline-block;
                width: 23px;
                height: 23px;
                background: url("../../assets/img/layer5/custom-bullet.png") no-repeat top;
                background-size: 100% 100%;
            }

            .custom-bullet-active {
                width: 23px;
                height: 23px;
                background: url("../../assets/img/layer5/custom-bullet-active.png") no-repeat top;
                background-size: 100% 100%;
            }
        }


    }

    .copy-right {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 120px;
        background-color: #26103b;
        display: flex;
        align-items: center;
        justify-content: center;

        .cnt {
            background-image: url("../../assets/img/layer5/copy-right.png");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            width: 482px;
            height: 52px;
            position: relative;


            .btn-privacypolicy {

                width: 140px;
                height: 20px;
                right: 90px;
                bottom: 0;
                position: absolute;
            }

            .btn-useragreement {
                width: 140px;
                height: 20px;
                position: absolute;
                left: 74px;
                bottom: 0;

            }

        }

        a {
            display: inline-block;
            margin: 0 12px;
        }
    }

    .r-cnt {
        margin-top: 36px;

        .cnt {
            height: 900px;
            max-height: 900px;
            overflow-y: scroll;
        }

        .ban-idx {
            margin: 32px auto;
            width: 706px;
            height: auto;
            border-radius: 6px;
        }

        .nav-1 {
            .title {
                width: 589px;
                height: 29px;
                margin: 0 auto;
            }
        }

    }
}

@media screen and (min-width: 375px) and(max-width: 429px) and (orientation : portrait) {
    .module-layer5 {
        .layer-cnt {
            top: 16vw !important;

            .r-cnt {
                margin-top: 20px !important;

                .cnt {
                    height: 870px !important;
                    max-height: 870px !important;

                }

                .ban-idx {
                    margin: 16px auto !important;
                    width: 635px !important;
                }
            }
        }
    }

}

@media screen and (min-width: 638px) and (max-width: 1024px) and (orientation : portrait) {
    .module-layer5 {
        .layer-cnt {
            top: 8% !important;

            .title {
                width: 288px !important;
                height: 141px !important;
            }

            .top-nav {
                margin-top: 3% !important;

                img {
                    width: 130px !important;
                    height: 41px !important;
                }
            }

            .r-cnt {
                .img-size {
                    width: 542px !important;
                    height: 306px !important;
                }
            }

            .swiper-button-prev {
                left: 5% !important;
            }

            .swiper-button-next {
                right: 5% !important;
            }

            .swiper-pagination-media {
                bottom: -7% !important;
            }
        }
    }

}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/layer5.vue